import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useEffect, useState } from "react";
import { BalootUserAPIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import SelectedFundsContainer from "../../../components/auto-investment/SelectedFundsContainer";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import AutoInvestmentFundSelectCard from "../../../components/auto-investment/AutoInvestmentFundSelectCard";
import { AddOrRemoveFund } from "../../../components/auto-investment/AddOrRemoveFund";
import { LoadingButton } from "@mui/lab";
import { useSnackBar } from "../../../context/SnackBarContext";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";

function AutoInvestmentAddOrRemovePage() {
  const navigate = useNavigate();
  const openSnack = useSnackBar();
  const location = useLocation();
  const fromContainer = location.state?.fromContainer;
  const {
    autoInvestmentFunds,
    autoInvestmentStatus,
    setAutoInvestmentStatus,
    fundsLoading,
  } = useOutletContext();
  const [selectedItems, setSelectedItems] = useState(
    autoInvestmentStatus.items
  );
  const { loading, apiCall: addAutoInvestmentItems } = useRequest(
    BalootUserAPIs.addAutoInvestmentItems
  );

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedAutoInvestItem, setSelectedAutoInvestItem] = useState({
    isAdd: true,
    assetId: 1,
    numberOfUnits: 1,
    fundInfo: {},
  });

  useEffect(() => {
    setSelectedItems(autoInvestmentStatus.items);
  }, [autoInvestmentStatus]);

  const handleSubmit = () => {
    addAutoInvestmentItems({
      data: { items: selectedItems.filter((item) => !Boolean(item.id)) },
      onSuccess: (response) => {
        setAutoInvestmentStatus(response);
        if (fromContainer) {
          navigate("../status", { replace: true });
        } else {
          navigate(-1);
        }
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              if (selectedItems.length === 0) {
                navigate("/app/navigation/investment");
              } else {
                navigate(-1);
              }
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            سرمایه‌گذاری خودکار
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <SelectedFundsContainer
          onItemClick={(item) => {
            setSelectedAutoInvestItem({
              ...item,
              isAdd: false,
            });
            setOpenDialog(true);
          }}
          selectedItems={selectedItems}
        />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 2 }}>
          {fundsLoading ? (
            <>
              <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
              <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
              <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
              <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
            </>
          ) : (
            <>
              {autoInvestmentFunds
                .filter(
                  (fund) =>
                    !selectedItems.some(
                      (selectedItem) => fund.assetId === selectedItem.assetId
                    )
                )
                .map((fund) => {
                  return (
                    <AutoInvestmentFundSelectCard
                      sx={{ my: 1 }}
                      key={fund.name}
                      fund={fund}
                      onClick={() => {
                        if (selectedItems.length === 3) {
                          openSnack(true, {
                            message: "حداکثر می‌توانید ۳ صندوق را انتخاب کنید",
                          });
                        } else {
                          setSelectedAutoInvestItem({
                            isAdd: true,
                            assetId: fund.assetId,
                            numberOfUnits: 1,
                            fundInfo: fund,
                          });
                          setOpenDialog(true);
                        }
                      }}
                    />
                  );
                })}
            </>
          )}
        </Box>
        <BottomFullWidthButtonContainer>
          <LoadingButton
            loading={loading}
            disabled={selectedItems.length === 0}
            onClick={handleSubmit}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            ذخیره
          </LoadingButton>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
      <AddOrRemoveFund
        open={openDialog}
        setOpen={setOpenDialog}
        setSelectedItems={setSelectedItems}
        selectedAutoInvestItem={selectedAutoInvestItem}
        setAutoInvestmentStatus={setAutoInvestmentStatus}
      />
    </>
  );
}

export default AutoInvestmentAddOrRemovePage;
